<template>
  <sui-page-tab-headless
    ref="tab"
    :tabItems="tabItems"
    :defaultTabIndex="defaultTabIndex"
    :setCurrentTabComponent="setCurrentTabComponent"
  >
    <container :is="currentTabComponent" @req-change-tabindex="changeTabIndex"/>
  </sui-page-tab-headless>  
</template>

<script>
// UI가 없는 tab, 하위 page에서 event 전달을 통해 tab 변경
// ex) this.$emit('req-change-tabindex', index)

const PGE_CMU_00001 = utils.getPageComponentById("PGE_CMU_00001");
const PGE_CMZ_00001 = utils.getPageComponentById("PGE_CMZ_00001");

export default {
  components: {
    PGE_CMU_00001,
    PGE_CMZ_00001,
  },
  data() {
    return {
      // Tab
      defaultTabIndex: 0,
      tabItems: [
        {
          tabTitle: "tab01",
          tabSubTitle: "sub01",
          component: "PGE_CMU_00001"
        },
        {
          tabTitle: "tab02",
          tabSubTitle: "sub02",
          component: "PGE_CMZ_00001"
        },
      ],
      currentTabComponent: null,
      tabIndex: 0
    };
  },
  methods: {
    setCurrentTabComponent(component) {
      this.currentTabComponent = component;
    },
    changeTabIndex(index) {
      this.$refs.tab.changeIdx(index);
    },    
  },
};
</script>
<style scoped>
</style>
